const WORDS = ["Mini Decors", "Thomala", "Garlands", "Jasmine", "Dindu", "Door Décor", "Marigold", "Tied Flowers", "Loose Flowers", "Roses"];

export const Marquee = () => (
  <section className="marquee-wrap relative overflow-hidden border-y border-[#D4AF37]/20 bg-[#190317] py-8 sm:py-12" data-testid="editorial-marquee" aria-label="Our specialities">
    <div className="marquee-track flex w-max items-center">
      {[...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`px-6 font-display text-5xl italic sm:px-10 sm:text-7xl lg:text-8xl ${i % 2 ? "text-outline" : "text-[#F3E5AB]"}`}>{w}</span>
          <span className="text-xl text-[#E91E63] sm:text-2xl">◆</span>
        </span>
      ))}
    </div>
  </section>
);
